import '../css/app.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';

// Pages
import Login from '@/Pages/Login';
import AuthCallback from '@/Pages/AuthCallback';
import Dashboard from '@/Pages/Dashboard';
import {
  Entradas,
  Estoque,
  Inventario,
  Medicos,
  Pacientes,
  Produtos,
  Receitas,
  Relatorios,
  Saidas,
  Saldo,
} from '@/Pages/SngpcListings';
import ExportarXml from '@/Pages/ExportarXml';
import Configuracoes from '@/Pages/Configuracoes';
import LayoutSettings from '@/Pages/LayoutSettings';
import { EntradaForm, ProdutoForm, ReceitaForm, SaidaForm } from '@/Pages/SngpcForms';

// Criar router com createBrowserRouter (data router)
const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/auth-callback',
    element: <AuthCallback />,
  },
  {
    path: '/',
    element: <ProtectedRoute />,
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: 'dashboard',
        element: <Dashboard />,
      },
      {
        path: 'produtos',
        element: <Produtos />,
      },
      { path: 'produtos/novo', element: <ProdutoForm /> },
      { path: 'produtos/:id/editar', element: <ProdutoForm /> },
      {
        path: 'entradas',
        element: <Entradas />,
      },
      { path: 'entradas/nova', element: <EntradaForm /> },
      { path: 'entradas/:id/editar', element: <EntradaForm /> },
      {
        path: 'saidas',
        element: <Saidas />,
      },
      { path: 'saidas/nova', element: <SaidaForm /> },
      { path: 'saidas/:id/editar', element: <SaidaForm /> },
      {
        path: 'receitas',
        element: <Receitas />,
      },
      { path: 'receitas/nova', element: <ReceitaForm /> },
      { path: 'receitas/:id/editar', element: <ReceitaForm /> },
      {
        path: 'medicos',
        element: <Medicos />,
      },
      {
        path: 'pacientes',
        element: <Pacientes />,
      },
      {
        path: 'estoque',
        element: <Estoque />,
      },
      {
        path: 'saldo',
        element: <Saldo />,
      },
      {
        path: 'inventario',
        element: <Inventario />,
      },
      {
        path: 'exportar-xml',
        element: <ExportarXml />,
      },
      {
        path: 'relatorios',
        element: <Relatorios />,
      },
      {
        path: 'configuracoes',
        element: <Configuracoes />,
      },
      {
        path: 'layout',
        element: <LayoutSettings />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);

const root = document.getElementById('app');

if (!root) {
  throw new Error('Root element not found');
}

createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </StrictMode>
);
